import t from "./highrise650.mjs";
import d from "./highrise1611.mjs";
import g from "./highrise1574.mjs";
import a from "./highrise1612.mjs";
import M from "./highrise661.mjs";
import v from "./highrise1338.mjs";
import x from "./highrise1613.mjs";
function D(f, r, e, n, i) {
  f !== r && g(r, function(o, m) {
    if (i || (i = new t()), M(o))
      a(f, r, m, e, D, n, i);
    else {
      var p = n ? n(x(f, m), o, m + "", f, r, i) : void 0;
      p === void 0 && (p = o), d(f, m, p);
    }
  }, v);
}
export {
  D as default
};
